import React from "react";
import { Box, IconButton } from "@mui/material";
import ViewListIcon from "@mui/icons-material/ViewList";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";

export default function ViewSizeSelector({ viewSize, setViewSize }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <IconButton
        color={viewSize === "small" ? "primary" : "default"}
        size="small"
        onClick={() => setViewSize("small")}
        aria-label="small view"
        title="Small view"
      >
        <ViewListIcon />
      </IconButton>
      <IconButton
        color={viewSize === "medium" ? "primary" : "default"}
        size="small"
        onClick={() => setViewSize("medium")}
        aria-label="medium view"
        title="Medium view"
      >
        <ViewModuleIcon />
      </IconButton>
      <IconButton
        color={viewSize === "large" ? "primary" : "default"}
        size="small"
        onClick={() => setViewSize("large")}
        aria-label="large view"
        title="Large view"
      >
        <ViewComfyIcon />
      </IconButton>
    </Box>
  );
}
